import { render, staticRenderFns } from "./RotinaLimpezaCPP.vue?vue&type=template&id=91961668&scoped=true"
import script from "./RotinaLimpezaCPP.vue?vue&type=script&lang=js"
export * from "./RotinaLimpezaCPP.vue?vue&type=script&lang=js"
import style0 from "./RotinaLimpezaCPP.vue?vue&type=style&index=0&id=91961668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91961668",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
